<template>
  <section>
    <div id="step-info" class="container">
      <div class="ws-textbox mb-4">
        <h2 class="title-choose-photo" :style="{ 'text-align': direction == 'rtl' ? 'right' : 'left' }">
          {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_10'] }}
        </h2>
        <div v-if="mealPlanInfo.bank_info.transfer_bank_info" class="mt-3 mb-3">
          <p class="bank-info">
            <span class="mr-2 pay-info-bold">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_28'] }}:</span>
            <span>{{ mealPlanInfo.bank_info.transfer_bank_info['Account Holder Name'] }}</span>
          </p>
          <p v-if="mealPlanInfo.bank_info.transfer_bank_info.Type == 'Email'" class="bank-info">
            <span class="mr-2 pay-info-bold">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_37'] || 'Email' }}:</span>
            <span>{{ mealPlanInfo.bank_info.transfer_bank_info['Email'] }}</span>
          </p>
          <p v-else class="bank-info">
            <span class="mr-2 pay-info-bold">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_29'] }}:</span>
            <span>{{ mealPlanInfo.bank_info.transfer_bank_info[' I B A N'] }}</span>
          </p>
        </div>
        <h2 class="title-choose-photo" :style="{ 'text-align': direction == 'rtl' ? 'right' : 'left' }">
          {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_25'] }}
        </h2>
        <div v-if="mealPlanInfo.bank_info.transfer_bank_info" class="mt-3 mb-3">
          <p class="d-flex justify-content-between">
            <span class="mr-2 pay-info-bold">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_30'] }}:</span>
            <span> {{ currency }} {{ formatPrice(creditAmount) }}</span>
          </p>
          <p v-for="(item, index) in mealPlanInfo.list_receipt" :key="index" class="d-flex justify-content-between">
            <span class="mr-2 pay-info-bold">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_31'] }}:</span>
            <span>{{ item.currency }} {{ item.amount }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <span class="mb-3 pay-info-bold">{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_32'] }}:</span>
            <span> {{ mealPlanInfo.bank_info.currency }} {{ mealPlanInfo.bank_info.target_amount }}</span>
          </p>
        </div>
      </div>
      <div class="button-download text-center">
        <div class="btn-handle">
          <button class="btnDefault btn-email" @click="onOpenEmailPopup()">
            {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_26'] }}
          </button>
        </div>
      </div>
    </div>
    <b-modal v-model="isOpenPopup" :modal-class="'ws-modal'" centered>
      <div class="d-flex flex-column align-items-center">
        <template v-if="step == 1">
          <p class="mb-2">
            {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_27'] }}
          </p>
          <input
            v-model="pax.email_address"
            required
            placeholder="Email"
            type="email"
            class="p-2 input-email-monetary"
            @focus="resetEmailValidate()"
          />
          <p v-if="!isEmailValidate" style="color: red">Email incorrect format!</p>
        </template>
        <template v-else-if="step == 2">
          <i style="color: #74d009; font-size: 5rem; margin-bottom: 1rem" class="fas fa-check-circle"></i>
          <p>{{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_33'] || 'Confirmation Sent' }}</p>
        </template>
      </div>
      <template #modal-footer>
        <div v-if="step == 1" class="ws-modal__footer w-100">
          <button class="btnDefault" @click="isOpenPopup = !isOpenPopup">
            {{ lang.meal_plan_photo_claim_new['SFS_LANG_ROW_53'] || 'Cancel' }}
          </button>
          <button class="btnDefault" @click="sendEmailConfirm()">
            {{ lang.meal_plan_photo_claim_new['SFS_LANG_TRANSFER_WISE_7'] || 'Confirm' }}
          </button>
        </div>
        <div v-else></div>
      </template>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'
import * as _ from 'lodash'

export default {
  name: 'StepInfo',
  props: {
    secret: {
      type: String,
      default: ''
    },
    mealPlanInfo: {
      type: Object,
      default: () => {}
    },
    MealPlanPriceTotalPax: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isOpenPopup: false,
      step: 1,
      isEmailValidate: true,
      timeDisappears: 5000,
      mealPlanService: {},
      creditAmount: 0,
      currency: 'EUR'
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services',
      direction: 'direction'
    })
    // Refreshment() {
    //   return _.find(this.Services, { service_id: 2 })
    // }
  },
  watch: {
    MealPlanPriceTotalPax: {
      handler() {
        if (this.MealPlanPriceTotalPax && this.MealPlanPriceTotalPax[0] && this.MealPlanPriceTotalPax[0].currency) {
          this.currency = this.MealPlanPriceTotalPax[0].currency
        }

        this.creditAmount = _.sumBy(this.MealPlanPriceTotalPax, function (o) {
          return parseFloat(o.valamount)
        })
      },
      deep: true
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    replaceStr,
    validateEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    initData() {
      this.mealPlanService = _.find(this.Services, { service_id: 23 })
      this.currency = this.mealPlanService.currency ? this.mealPlanService.currency : this.currency
      if (this.MealPlanPriceTotalPax && this.MealPlanPriceTotalPax[0] && this.MealPlanPriceTotalPax[0].currency) {
        this.currency = this.MealPlanPriceTotalPax[0].currency
      }
      if (this.MealPlanPriceTotalPax) {
        this.creditAmount = _.sumBy(this.MealPlanPriceTotalPax, function (o) {
          return parseFloat(o.valamount)
        })
      }
    },
    onOpenEmailPopup: function () {
      this.isOpenPopup = !this.isOpenPopup
      this.step = 1
    },
    resetEmailValidate: function () {
      this.isEmailValidate = true
    },
    totalClaimed: function () {
      if (this.mealPlanInfo.list_receipt.length) {
        let total = this.mealPlanInfo.list_receipt.reduce((previousValue, currentValue) => {
          return previousValue + parseFloat(currentValue.amount)
        }, 0)
        return total
      }
      return 0
    },
    sendEmailConfirm: function () {
      var self = this
      if (!this.validateEmail(this.pax.email_address)) {
        this.isEmailValidate = false
        return
      }
      let dataSend = {
        data: {
          email: this.pax.email_address,
          credit: this.formatPrice(this.creditAmount),
          claimed: this.totalClaimed().toFixed(2),
          transferred: this.mealPlanInfo.bank_info.target_amount,
          currency: this.mealPlanInfo.bank_info.currency,
          full_name: this.pax.full_name,
          iban:
            this.mealPlanInfo.bank_info.transfer_bank_info[' I B A N'] ||
            this.mealPlanInfo.bank_info.transfer_bank_info['Account Number'],
          transferId: this.mealPlanInfo.bank_info.transfer_id,
          secret: self.secret,
          block_code: this.mealPlanInfo.bank_info.block_code || '',
          voucher_code: this.mealPlanInfo.bank_info.voucher_code || ''
        },
        secret: self.secret
      }
      this.$store.dispatch('sendEmailConfirmReceipt', dataSend).then((response) => {
        if (response) {
          if (response.success == false) {
            this.isOpenPopup = !this.isOpenPopup
            return
          }
          this.step = 2
          setTimeout(
            function () {
              self.isOpenPopup = false
            },
            self.timeDisappears,
            self
          )
        }
      })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2)
      return val.toString()
    }
  }
}
</script>
